import Controller from '@ember/controller';

import { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import { inject as controller } from '@ember/controller';
import { inject as service } from '@ember/service';

export default class GiftController extends Controller {
  @controller('application') applicationController;
  @service session;

  @tracked giftSelected;
  @tracked gift_message;
  @tracked gift_style;
  @tracked style_def;

  defStyle = [
    {
      name: 'style_1',
      preview_img: 'https://beebeeassets.beebeeboard.com/img/grafica_voucher/style_1.png',
    },
    {
      name: 'style_2',
      preview_img: 'https://beebeeassets.beebeeboard.com/img/grafica_voucher/style_2.png',
    },
    {
      name: 'style_3',
      preview_img: 'https://beebeeassets.beebeeboard.com/img/grafica_voucher/style_3.png',
    },
    {
      name: 'style_4',
      preview_img: 'https://beebeeassets.beebeeboard.com/img/grafica_voucher/style_4.png',
    },
  ];

  get listStyles() {
    // copy: avoid mutating the shared class-field default array across recomputes
    let defStyle = [...this.defStyle];

    const option_field = this.session.option_field;
    const { voucher } = option_field || {};

    if (voucher?.hide_default) {
      defStyle = [];
    }

    const { custom_styles } = voucher || {};

    if (Array.isArray(custom_styles)) {
      defStyle.push(...custom_styles);
    }

    const selected = defStyle.find((item) => item.selected === true);
    // defStyle can be empty when hide_default is set and the tenant has no
    // custom styles: guard against dereferencing undefined.
    if (!selected && defStyle.length > 0) {
      set(defStyle[0], 'selected', true);
    }

    return defStyle.filter((style) => style.only_segreteria !== true);
  }

  get ecommerceGiftVoucher() {
    const vouchers = this.session.option_field?.ecommerce_gift_voucher;

    if (Array.isArray(vouchers)) {
      return vouchers.filter((voucher) => voucher.only_segreteria !== true);
    }

    return [];
  }

  @action
  addCart() {
    // giftSelected is null until a voucher is picked; the "add" button can be
    // clicked while still disabled (Sentry EMBER-SCUOLE-ECOMMERCE-28D), so guard
    // with optional chaining instead of dereferencing a possibly-undefined object.
    if (!this.giftSelected?.id || !this.giftSelected?.total) {
      return;
    }

    const styleSelected = this.listStyles.find((i) => i.selected === true);
    const voucher = {
      gift: this.giftSelected,
      gift_message: this.gift_message,
      gift_style: styleSelected,
      product_status_id: 0,
    };

    this.applicationController.addCart('voucher', voucher);
  }

  @action
  selectVoucher(voucher) {
    if (voucher.id === (this.giftSelected && this.giftSelected.id)) {
      set(this, 'giftSelected', null);
      return;
    }

    const selStyle = this.listStyles.find((i) => i.selected === true);

    if (!selStyle) {
      return;
    }

    this.giftSelected = voucher;
    this.gift_message = null;
    this.gift_style = null;
    this.style_def = selStyle;

    const stepEl = document.getElementById('voucherStep2');

    if (stepEl) {
      const rect = stepEl.getBoundingClientRect();
      const stepSlide = rect.top + window.scrollY;

      window.scrollTo({ top: stepSlide + 200, behavior: 'smooth' });
    }
  }

  @action
  styleSelected(style) {
    this.listStyles.forEach((s) => set(s, 'selected', false));
    set(style, 'selected', true);
  }
}
